<template>
  <div class="modal-card animation-content">
    <section class="modal-card-body">
      <p>Choose Color</p>
      <div class="colors">
        <!-- eslint-disable-next-line vue/require-v-for-key -->
        <div class="colors__item"
             v-for="color in colors"
             :class="{'colors__items--selected': selectedColor == color}"
             @click="selectedColor = color">
          <div :style="{ backgroundColor: color }">
            <i v-if="color == ''" class="mdi mdi-close" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" @click="$emit('close')">Cancel</button>
      <button class="button is-primary" @click="$emit('save', selectedColor || '');$emit('close')">Done</button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "ColorPicker",
  props: ['color'],
  data() {
    return {
      selectedColor: this.color,
      colors: [
          '',
          'rgba(192,57,43,0.7)',
          'rgba(41,128,185,0.7)',
          'rgba(230,126,34,0.7)',
          'rgba(241,196,15,0.7)',
          'rgba(46,204,113,0.7)'
      ]
    }
  }
}
</script>

<style scoped>
  .colors {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    justify-content: space-between;
  }
  .colors__item {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
    overflow: hidden;
    padding: 2px;
  }
  .colors__item > div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .colors__item > div > i {
    font-size: 20px;
    padding-top: 2px;
  }
  .colors__item.colors__items--selected {
    border: 2px solid var(--ld-text-primary);
  }
</style>
